import { makeStyles, Theme } from '@material-ui/core/styles';
import { THEME_MODES } from 'src/theming';

export const useContractDashboardAonStyle = makeStyles((theme: Theme) => {
    return {
        dashboardContainer: {
            flexDirection: 'column',
            height: '100%',
        },
        toolBar: {
            height: 75,
            alignItems: 'center',
            flexWrap: 'nowrap',
            padding: `0 ${theme.spacing(1)}rem`,
            backgroundColor: ({
                isDarkMode,
            }: {
                isDarkMode: boolean;
                editMode: boolean;
            }) => (isDarkMode ? theme.palette.primary.main : theme.palette.primary.light),
            borderBottom: ({ isDarkMode }: { isDarkMode: boolean; editMode: boolean }) =>
                isDarkMode ? `1px solid rgba(255, 255, 255, 0.2)` : 'none',
            [theme.breakpoints.down('md')]: {
                height: 60,
                padding: `0 ${theme.spacing(1)}px`,
            },
        },
        radioButtonLabel: {
            [theme.breakpoints.down('md')]: {
                '& .MuiFormControlLabel-label': {
                    fontSize: '1.4rem',
                },
            },
        },
        radioFormControl: {
            minWidth: 300,
            [theme.breakpoints.down('md')]: {
                minWidth: 245,
            },
        },
        dragContractType: {
            '&:after': {
                content: '""',
                position: 'absolute',
                top: 0,
                bottom: 0,
                left: 0,
                right: 0,
                backgroundImage: `repeating-linear-gradient(-45deg, ${theme.palette.info.light}, ${theme.palette.info.light} 25px, ${theme.palette.secondary.main} 25px, ${theme.palette.secondary.main} 50px)`,
                border: `2px dashed ${theme.palette.info.main}`,
                zIndex: 1000,
            },
        },
        searchIcon: {
            width: 24,
            height: 24,
            opacity: 0.6,
        },
        cardData: {
            width: '60%',
        },
        quickActionsButton: {
            minWidth: 300,
            marginRight: theme.spacing(4),
            marginBottom: theme.spacing(4),
            height: 40,
            padding: `0 ${theme.spacing(5)}px`,
            backgroundColor: theme.palette.info.light,
            color: theme.palette.primary.contrastText,
            transition: '0.2s',
            '&:hover': {
                backgroundColor: theme.palette.info.light,
                opacity: 0.8,
            },
        },
        showMoreLink: {
            display: 'inline-block',
            marginLeft: 'auto',
            marginRight: `${theme.spacing(1)}rem`,
            marginTop: theme.spacing(1),
            marginBottom: theme.spacing(2),
            fontWeight: theme.typography.fontWeightMedium,
        },
        searchButton: {
            height: 40,
            padding: `0 ${theme.spacing(4)}px`,
            backgroundColor:
                theme.palette.type === THEME_MODES.DARK
                    ? theme.palette.info.main
                    : theme.palette.secondary.main,
            color: theme.palette.info.contrastText,
            transition: '0.2s',
            '&:hover': {
                opacity: 0.6,
                backgroundColor:
                    theme.palette.type === THEME_MODES.DARK
                        ? theme.palette.info.main
                        : theme.palette.secondary.main,
            },
            '&.Mui-disabled': {
                opacity: 0.6,
                color: theme.palette.secondary.contrastText,
            },
        },
        contractsDashboardContainer: {
            padding: `${theme.spacing(4)}px ${theme.spacing(1)}rem`,
            [theme.breakpoints.down('md')]: {
                padding: `${theme.spacing(2)}px ${theme.spacing(1)}px`,
            },
        },
        cardsContainer: {
            width: '30%',
            paddingRight: theme.spacing(4),
            opacity: ({ editMode }: { editMode: boolean; isDarkMode: boolean }) =>
                editMode ? 0.4 : 1,
        },
        chartsContainer: {
            width: '70%',
            paddingLeft: theme.spacing(4),
            opacity: ({ editMode }: { editMode: boolean; isDarkMode: boolean }) =>
                editMode ? 0.4 : 1,
        },
        quickActionsContainer: {
            width: '30%',
            padding: `${theme.spacing(4)}px ${theme.spacing(1)}rem`,
            [theme.breakpoints.down('md')]: {
                padding: `${theme.spacing(2)}px ${theme.spacing(1)}px`,
            },
        },
        divisionsContainer: {
            width: '100%',
            paddingTop: theme.spacing(4),
        },
        card: {
            width: '100%',
            '&:not(:last-child)': {
                marginBottom: theme.spacing(6),
            },
        },
        chart: {
            width: '50%',
        },
        linearChart: {
            width: '100%',
        },
        dashboardSettingsContainer: {
            padding: `${theme.spacing(3)}px ${theme.spacing(1)}rem`,
            [theme.breakpoints.down('md')]: {
                padding: `${theme.spacing(3)}px ${theme.spacing(2)}px`,
            },
        },
        printButton: {
            width: 40,
            height: 40,
            marginRight: theme.spacing(2),
            borderRadius: 4,
            backgroundColor: theme.palette.info.light,
            color: theme.palette.info.main,
            '& .MuiSvgIcon-root': {
                width: 20,
                height: 20,
            },
        },
        damageLinkButton: {
            width: 300,
            height: 40,
            padding: `0 ${theme.spacing(5)}px`,
            marginRight: theme.spacing(4),
            marginBottom: theme.spacing(4),
            backgroundColor: theme.palette.info.light,
            color: theme.palette.primary.contrastText,
            transition: '0.2s',
            '& .MuiTypography-root': {
                fontSize: '1.6rem',
            },
            '&:hover': {
                backgroundColor: theme.palette.info.light,
                opacity: 0.8,
            },
        },
        searchFieldContainer: {
            display: 'flex',
            flexWrap: 'nowrap',
            width: '35%',
            [theme.breakpoints.down('lg')]: {
                width: '28%',
                '& .MuiFormControl-root': {
                    marginRight: theme.spacing(2),
                },
            },
        },
    };
});

export const useFormControlYearAonStyles = makeStyles((theme: Theme) => {
    const isLightMode = THEME_MODES.LIGHT === theme.palette.type;

    return {
        root: {
            '& .MuiInputBase-root': {
                borderRadius: 5,
            },
            '& .MuiOutlinedInput-notchedOutline': {
                border: isLightMode
                    ? `1px solid ${theme.palette.secondary.main}`
                    : `1px solid ${theme.palette.secondary.contrastText}`,
            },
        },
    };
});

export const useFormControlAonStyles = makeStyles((theme: Theme) => {
    return {
        root: {
            maxWidth: '30%',
            margin: `0 ${theme.spacing(4)}px 0 0`,
            '& label': {
                fontSize: '2.4rem',
            },
        },
    };
});

export const useInputAonStyles = makeStyles((theme: Theme) => {
    return {
        root: {
            width: '100%',
            height: 40,
            backgroundColor: ({ isDarkMode }: { isDarkMode: boolean }) =>
                isDarkMode ? theme.palette.primary.main : theme.palette.primary.light,
        },
        focused: {
            '& fieldSet': {
                borderColor: `${theme.palette.info.main}!important`,
            },
        },
        input: {
            '&:-webkit-autofill': {
                transitionDelay: '9999s',
                transitionProperty: 'background-color',
                boxShadow: 'none',
            },
        },
    };
});

export const useFormControlLabelAonStyles = makeStyles((theme: Theme) => {
    return {
        root: {
            display: 'flex!important',
            alignItems: 'center',
            margin: 0,
            padding: `0!important`,
            '&>div': {
                width: '100%',
                '& .MuiFormControl-root': {
                    width: '100%',
                },
            },
        },
        label: {
            fontSize: '1.6rem',
            marginRight: theme.spacing(4),
        },
    };
});

export const useDashboardActionsAonStyle = makeStyles((theme: Theme) => {
    return {
        editModeButtons: {
            width: '50%',
            marginLeft: theme.spacing(3),
            '&>button': {
                height: 40,
                padding: `0 ${theme.spacing(4)}px`,
                marginRight: theme.spacing(3),
                backgroundColor: theme.palette.info.light,
                color: theme.palette.info.main,
                borderRadius: 2,
                '&[data-mode=edit]': {
                    backgroundColor: theme.palette.primary.main,
                    border: `1px solid ${theme.palette.grey.A100}`,
                },
            },
        },
        saveButton: {
            '& .MuiCircularProgress-svg': {
                color: theme.palette.info.main,
            },
        },
    };
});
